import React from 'react';
import { contentNotePropTypes } from './ContentNotePropTypes';
import Heading from '@Theme/natucare/modules/Footer/components/Heading/Heading';
import * as styles from './ContentNote.module.scss';
const ContentNote = _ref => {
  let {
    heading,
    description
  } = _ref;
  if (!heading && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Heading, {
    heading: heading
  }), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description));
};
export default ContentNote;